import { render, staticRenderFns } from "./DeletedPublicOrders.vue?vue&type=template&id=354c3ed4"
import script from "./DeletedPublicOrders.vue?vue&type=script&lang=js"
export * from "./DeletedPublicOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports